import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Navigate } from 'react-router';
import { LAST_SESSION_KEY } from '@/constants/storage';

export function SessionTokenGuard({ children }: { children: React.ReactNode }) {
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    if (token) {
      sessionStorage.setItem(LAST_SESSION_KEY, token);
    }
  }, [token]);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
